var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistorical = function SvgHistorical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2a7.5 7.5 0 0 0-5.16 2.077V2.75a.75.75 0 0 0-1.5 0v3.375a.75.75 0 0 0 .75.75h3.375a.75.75 0 0 0 0-1.5h-1.8A6 6 0 1 1 3 9.5a.75.75 0 0 0-1.5 0A7.5 7.5 0 1 0 9 2Zm0 4.5a.75.75 0 0 0-.75.75V9.5a.75.75 0 0 0 .75.75h1.5a.75.75 0 1 0 0-1.5h-.75v-1.5A.75.75 0 0 0 9 6.5Z"
  })));
};
export default SvgHistorical;